import { css } from 'styled-components';
var base = 8;
export function getShadow() {
  var strength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var placement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'center';
  var blur = base * strength;
  var distance = blur / 4;
  var opacity = blur * 2 / 100;
  var spread = -1 * (distance / 2);
  var xDelta = placement.match('(left|right)') ? distance : 0;
  var yDelta = placement.match('(top|bottom)') ? distance : 0;
  var xMagnitude = placement.match('left') ? -1 : 1;
  var yMagnitude = placement.match('top') ? -1 : 1;
  return css(["box-shadow:", ";"], "".concat(xMagnitude * xDelta, "px ").concat(yMagnitude * yDelta, "px ").concat(blur, "px ").concat(spread, "px hsla(200, 10%, 15%, ").concat(opacity, ")"));
}
//# sourceMappingURL=shadows.js.map